﻿import EstrategyPassword, { PasswordStrengthConfig, RequirementIconBehaviour } from "../../../library/estrategy/estrategy.password";

document.addEventListener("DOMContentLoaded", () =>
{    
    document.querySelectorAll(".js-password-checker")?.forEach((item: HTMLInputElement) =>
    {        
        var iconBehaviour = RequirementIconBehaviour.Default;
        if ($(item).data("type") == "validatenotempty")
            iconBehaviour = RequirementIconBehaviour.ValidateNotEmpty;
        else if ($(item).data("type") == "validateimmediately")
            iconBehaviour = RequirementIconBehaviour.ValidateImmediately;

        const options = new PasswordStrengthConfig();
        options.customClass = ".js-password-checker-holder";
        options.showStrengthText = false;
        options.showProgressBar = false;
        options.iconBehaviour = iconBehaviour;
        const passwordChecker = new EstrategyPassword(item, options);
    });
});